import { h } from 'preact'
import { useEffect, useRef, useState } from 'preact/hooks'
import { isElementInViewport, getComputedStyleProp } from 'utils/dom'

export default function Facet({ label, options, onSelect, onRemove }) {
	const listItemRef = useRef(null)
	const dropdownRef = useRef(null)

	const [isOpen, setIsOpen] = useState(null)
	const toggle = () => setIsOpen(!isOpen)

	useEffect(() => {
		const windowClickEvent = e => {
			if (listItemRef.current !== null && !listItemRef.current.contains(e.target))
				setIsOpen(!isOpen)
		}

		if (isOpen) {
			window.addEventListener('click', windowClickEvent)
		}

		return () => {
			window.removeEventListener('click', windowClickEvent)
		}
	}, [isOpen, listItemRef])

	const checkCollisions = () => {
		if (isOpen) {
			/**
			 ** Will move a facet if it doesnt fit inside the screen when opened.
			 */
			if (!isElementInViewport(dropdownRef.current)) {
				const bounds = dropdownRef.current.getBoundingClientRect()
				const offset = getComputedStyleProp(null, 'font-size') // => '16px'
                const offsetN = parseInt(offset, 2) // => 16

				dropdownRef.current.style.left = `-${bounds.left - 16}px`
				dropdownRef.current.style.width = `calc(100vw - ${16 * 2}px)` // 2 rem depending on zoom level
				dropdownRef.current.style.right = 'unset'
			}
		}
	}

	return (
		// eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
		<li ref={listItemRef} onClick={checkCollisions}>
			<div
				className={`wsu-facet-label ${isOpen ? 'open' : ''}`}
				onClick={toggle}
				tabIndex={0}
				role="button"
			>
				<div className="facet-label-row">
					<span>{label}</span>

					<svg
						width="16"
						height="16"
						viewBox="0 0 48 48"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8.36612 16.1161C7.87796 16.6043 7.87796 17.3957 8.36612 17.8839L23.1161 32.6339C23.6043 33.122 24.3957 33.122 24.8839 32.6339L39.6339 17.8839C40.122 17.3957 40.122 16.6043 39.6339 16.1161C39.1457 15.628 38.3543 15.628 37.8661 16.1161L24 29.9822L10.1339 16.1161C9.64573 15.628 8.85427 15.628 8.36612 16.1161Z"
							fill="var(--md-gray-950)"
						/>
					</svg>
				</div>
			</div>

			{isOpen && (
				<div ref={dropdownRef} className="wsu-dropdown">
					<ul className="wsu-facet">
						{options.map(option => {
							const checked = option.selected
							const disabled = option.count == 0
							return (
								<li
									key={`${option.name}-${option.url}`}
									className={option.count <= 0 ? 'disabled' : ''}
								>
									<label htmlFor={`wsu-facet__${label}_${option.name}`}>
										<div className="wsu-checkbox-wrapper">
											<input
												type="checkbox"
												id={`wsu-facet__${label}_${option.name}`}
												onChange={() => {
													if (option.count == 0) {
														return
													}
													checked
														? onRemove(option.name)
														: onSelect(option.name)
												}}
												defaultChecked={checked}
												disabled={disabled}
											/>
											<span className="wsu-checkbox-label">
												{option.name}
											</span>
										</div>
										<span className="wsu-facet-count">{option.count}</span>
									</label>
								</li>
							)
						})}
					</ul>
				</div>
			)}
		</li>
	)
}